import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Hidden,
  Link,
  SvgIcon,
  Button,
  Toolbar,
  makeStyles
} from "@material-ui/core";
import useSettings from 'src/hooks/useSettings';

const useStyles = makeStyles((theme) => ({
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px 11px',
    
  },
  topTextA: {
    fontFamily: 'Montserrat',
    fontSize: '34px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '33.6px',
    color: '#FFFFFF',
    letterSpacing: 0,
    textAlign: 'center'
  },
  topTextB: {
    fontFamily: 'Montserrat',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
    color: '#FFFFFF',
    lineHeight: '21.6px',
    letterSpacing: 0,
    textAlign: 'center',
    // marginLeft: 10,
    // paddingTop: 8
  },
}));

const Logo = (props) => {
  const classes = useStyles();
  const {settings} = useSettings();
  
  return (
    // <Box className={classes.logoContainer}>
      <SvgIcon {...props}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="3" width="6" height="5" rx="1" stroke="#4AC1E0" stroke-width="2"/>
        <rect x="14" y="16" width="6" height="5" rx="1" stroke="#4AC1E0" stroke-width="2"/>
        <rect x="4" y="12" width="6" height="9" rx="1" stroke="#4AC1E0" stroke-width="2"/>
        <rect x="14" y="3" width="6" height="9" rx="1" stroke="#4AC1E0" stroke-width="2"/>
        </svg>
        {/* <img src={'/static/icons/icon_dash_active.svg'} width='24' title='Dashboard'/> */}
      </SvgIcon>
    // </Box>
  );
}

export default Logo;
